<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>
          {{ 'KnittingOrderBalance.knittingOrderYarnBalance' | translateWF: 'Knitting Order Yarn Balance' }}
        </h1>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'KnittingOrderBalance.knittingOrderYarnBalance' | translateWF: 'Knitting Order Yarn Balance'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table
            [value]="knittingOrderBalances()"
            styleClass="cs-datatable-compact"
            dataKey="knittingOrderId"
            [lazy]="true"
            (onSort)="onSort($event)"
            sortMode="multiple"
            [loading]="isLoading() > 0"
            responsiveLayout="scroll"
            [rowHover]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"></th>
                <th>
                  {{ 'KnittingOrderBalance.status' | translateWF: 'Status' }}
                </th>
                <th pSortableColumn="knittingOrderNumber">
                  {{ 'KnittingOrderBalance.orderNumber' | translateWF: 'Order Number' }}
                  <p-sortIcon field="knittingOrderNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="workOrderNumber">
                  {{ 'KnittingOrderBalance.workOrder' | translateWF: 'Work Order' }}
                  <p-sortIcon field="workOrderNumber"></p-sortIcon>
                </th>
                <th pSortableColumn="manufacturerLotNumbers">
                  {{ 'KnittingOrderBalance.lotNumbers' | translateWF: 'Lot Numbers' }}
                </th>
                <th pSortableColumn="totalLotItems">
                  {{ 'KnittingOrderBalance.lotItemsCount' | translateWF: 'Lot Items' }}
                  <p-sortIcon field="totalLotItems"></p-sortIcon>
                </th>
                <th pSortableColumn="totalOriginalQuantity">
                  {{ 'KnittingOrderBalance.originalQty' | translateWF: 'Original Qty' }}
                  <p-sortIcon field="totalOriginalQuantity"></p-sortIcon>
                </th>
                <th pSortableColumn="totalReturnedQuantity">
                  {{ 'KnittingOrderBalance.returnedQty' | translateWF: 'Returned Qty' }}
                  <p-sortIcon field="totalReturnedQuantity"></p-sortIcon>
                </th>
                <th pSortableColumn="totalCurrentQuantity">
                  {{ 'KnittingOrderBalance.remainingQty' | translateWF: 'Remaining Qty' }}
                  <p-sortIcon field="totalCurrentQuantity"></p-sortIcon>
                </th>
                <th>
                  {{ 'KnittingOrderBalance.KnittingOrderPlannedQuantity' | translateWF: 'KO Planned Quantity' }}
                </th>
                <th>
                  {{ 'KnittingOrderBalance.KnittingOrderIssuedQuantity' | translateWF: 'KO Issued Quantity' }}
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-order let-expanded="expanded">
              <tr [class.row-expanded]="expanded">
                <td>
                  <p-button
                    type="button"
                    pRipple
                    [pRowToggler]="order"
                    [text]="true"
                    [rounded]="true"
                    [plain]="true"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  >
                  </p-button>
                </td>
                <td>
                  {{ statusOptions[order.status] }}
                </td>
                <td>
                  <span class="font-mono font-semibold">{{ order.knittingOrderNumber }}</span>
                </td>
                <td>
                  <span class="font-mono">{{ order.workOrderNumber }}</span>
                </td>
                <td>{{ order.manufacturerLotNumbers }}</td>
                <td>
                  <p-tag [value]="order.totalLotItems.toString()" severity="info"></p-tag>
                </td>
                <td>
                  <span>{{ order.totalOriginalQuantity | number: '1.2-2' }}</span>
                </td>
                <td>
                  <span>{{ order.totalReturnedQuantity | number: '1.2-2' }}</span>
                </td>
                <td>
                  <span class="font-semibold">{{ order.totalCurrentQuantity | number: '1.2-2' }}</span>
                </td>
                <td>{{ order.plannedQuantity | number: '1.2-2' }}</td>
                <td>{{ order.issuedQuantity | number: '1.2-2' }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-order>
              <tr>
                <td colspan="11">
                  <div class="p-4">
                    <h4 class="text-lg font-semibold mb-3">
                      {{ 'KnittingOrderBalance.requisitionDetails' | translateWF: 'Requisition Details' }}
                    </h4>

                    <p-accordion [multiple]="true" styleClass="cs-accordion-compact">
                      <p-accordionTab *ngFor="let req of order.requisitions" [header]="req.requisitionNumber">
                        <p-table
                          [value]="req.lotItems"
                          styleClass="cs-datatable-compact cs-datatable-no-hover"
                          [scrollable]="true"
                          scrollHeight="300px"
                          [showCurrentPageReport]="true"
                          currentPageReportTemplate="{totalRecords} lot items"
                        >
                          <ng-template pTemplate="header">
                            <tr>
                              <th>{{ 'KnittingOrderBalance.lotItemNumber' | translateWF: 'Lot Item Number' }}</th>

                              <th>{{ 'KnittingOrderBalance.lotNumber' | translateWF: 'Lot Number' }}</th>
                              <th>{{ 'KnittingOrderBalance.itemCode' | translateWF: 'Item Code' }}</th>
                              <th>{{ 'KnittingOrderBalance.itemDescription' | translateWF: 'Description' }}</th>
                              <th>{{ 'KnittingOrderBalance.providerLot' | translateWF: 'Provider Lot' }}</th>
                              <th>{{ 'KnittingOrderBalance.originalQty' | translateWF: 'Original' }}</th>
                              <th>{{ 'KnittingOrderBalance.remainingQty' | translateWF: 'Remaining' }}</th>
                              <th>{{ 'KnittingOrderBalance.consumedQty' | translateWF: 'Consumed' }}</th>
                              <th>{{ 'KnittingOrderBalance.uom' | translateWF: 'UOM' }}</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-lot>
                            <tr>
                              <td>
                                <span class="font-mono text-sm">{{ lot.lotItemNumber }}</span>
                              </td>
                              <td>
                                <span class="font-mono text-sm">{{ lot.manufacturerLotNumber }}</span>
                              </td>
                              <td>
                                <span class="font-mono text-sm">{{ lot.itemCode }}</span>
                              </td>

                              <td>
                                <span class="text-sm" [title]="lot.itemDescription">
                                  {{ lot.itemDescription.length > 50 ? (lot.itemDescription | slice: 0 : 50) + '...' : lot.itemDescription }}
                                </span>
                              </td>
                              <td>
                                <span class="font-mono text-sm">{{ lot.providerLotNumber }}</span>
                              </td>
                              <td>
                                <span class="font-semibold">{{ lot.originalQuantity | number: '1.2-2' }}</span>
                              </td>
                              <td>
                                <span class="font-semibold">{{ lot.currentQuantity | number: '1.2-2' }}</span>
                              </td>
                              <td>
                                <span class="font-semibold">{{ lot.consumedQuantity | number: '1.2-2' }}</span>
                              </td>
                              <td>
                                <p-tag [value]="lot.unitOfMeasure" severity="secondary"></p-tag>
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="footer">
                            <tr class="font-semibold bg-gray-50">
                              <td colspan="5" class="text-right">
                                <strong>{{ 'KnittingOrderBalance.totals' | translateWF: 'Totals' }}:</strong>
                              </td>
                              <td class="text-right">
                                <strong>{{ req.totalOriginalQuantity | number: '1.2-2' }}</strong>
                              </td>
                              <td class="text-right">
                                <strong>{{ req.totalCurrentQuantity | number: '1.2-2' }}</strong>
                              </td>
                              <td class="text-right">
                                <strong>{{ req.totalConsumedQuantity | number: '1.2-2' }}</strong>
                              </td>
                              <td></td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-accordionTab>
                    </p-accordion>

                    <!-- Returned Lot Items Section -->
                    <div *ngIf="order.returnedLotItems && order.returnedLotItems.length > 0" class="mt-6">
                      <h4 class="text-lg font-semibold mb-3 text-orange-600">
                        {{ 'KnittingOrderBalance.returnedLotItems' | translateWF: 'Returned Lot Items' }}
                      </h4>

                      <p-message
                        severity="info"
                        styleClass="mb-3"
                        [text]="
                          'KnittingOrderBalance.returnedItemsNote'
                            | translateWF
                              : 'Note: Returned items show the original quantity at the time of return. The current quantity in inventory may differ due to subsequent transactions or usage by other requisitions.'
                        "
                      ></p-message>

                      <p-table
                        [value]="order.returnedLotItems"
                        styleClass="cs-datatable-compact cs-datatable-no-hover"
                        [scrollable]="true"
                        scrollHeight="250px"
                        [showCurrentPageReport]="true"
                        currentPageReportTemplate="{totalRecords} returned items"
                      >
                        <ng-template pTemplate="header">
                          <tr>
                            <th>{{ 'KnittingOrderBalance.lotItemNumber' | translateWF: 'Lot Item Number' }}</th>
                            <th>{{ 'KnittingOrderBalance.lotNumber' | translateWF: 'Lot Number' }}</th>
                            <th>{{ 'KnittingOrderBalance.itemCode' | translateWF: 'Item Code' }}</th>
                            <th>{{ 'KnittingOrderBalance.itemDescription' | translateWF: 'Description' }}</th>
                            <th>{{ 'KnittingOrderBalance.providerLot' | translateWF: 'Provider Lot' }}</th>
                            <th>{{ 'KnittingOrderBalance.returnedQty' | translateWF: 'Returned (Original Qty)' }}</th>
                            <th>{{ 'KnittingOrderBalance.uom' | translateWF: 'UOM' }}</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-returnedLot>
                          <tr>
                            <td>
                              <span class="font-mono text-sm">{{ returnedLot.lotItemNumber }}</span>
                            </td>
                            <td>
                              <span class="font-mono text-sm">{{ returnedLot.manufacturerLotNumber }}</span>
                            </td>
                            <td>
                              <span class="font-mono text-sm">{{ returnedLot.itemCode }}</span>
                            </td>
                            <td>
                              <span class="text-sm" [title]="returnedLot.itemDescription">
                                {{ returnedLot.itemDescription.length > 50 ? (returnedLot.itemDescription | slice: 0 : 50) + '...' : returnedLot.itemDescription }}
                              </span>
                            </td>
                            <td>
                              <span class="font-mono text-sm">{{ returnedLot.providerLotNumber }}</span>
                            </td>
                            <td>
                              <span class="font-semibold text-orange-600">{{ returnedLot.originalQuantity | number: '1.2-2' }}</span>
                            </td>
                            <td>
                              <p-tag [value]="returnedLot.unitOfMeasure" severity="warn"></p-tag>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                          <tr class="font-semibold bg-orange-50">
                            <td colspan="5" class="text-right">
                              <strong>{{ 'KnittingOrderBalance.totalReturned' | translateWF: 'Total Returned' }}:</strong>
                            </td>
                            <td class="text-right">
                              <strong class="text-orange-600">{{ getReturnedQuantityForOrder(order) | number: '1.2-2' }}</strong>
                            </td>
                            <td></td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="11" class="text-center py-8">
                  <i class="pi pi-info-circle text-4xl text-gray-300 mb-4 block"></i>
                  <p class="text-gray-500 text-lg">
                    {{ 'KnittingOrderBalance.noData' | translateWF: 'No knitting order balance data available.' }}
                  </p>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[50, 100, 200]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
